import { render, staticRenderFns } from "./wysiwyg.vue?vue&type=template&id=09fe2d74"
import script from "./wysiwyg.js?vue&type=script&lang=js&external"
export * from "./wysiwyg.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports